export const getRequesterRole = (isOm: boolean, isTm: boolean): string => {
  if (isOm) {
    return 'OM';
  } else if (isTm) {
    return 'TM';
  }
  return 'CSA';
};
